import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchBank } from "../../../../../../features/dropdown/dropdownSlice";
import { paymentMethodsData } from "../../../../../../data";

import PhoneInput from "react-phone-input-2";
import { save } from "../../../../../../features/save/saveSlice";

const { TextArea } = Input;

const PaymentDetailsModal = ({
  open,
  handleCancel,
  handleFetchData,
  setopenSingle,
  prodd,
  phPayeeType,
  pdPhId,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bank, staffGradeData, loading } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.save);
  const { singlePaymentObj } = useSelector((state) => state.folder);

  const [openVerification, setopenVerification] = useState(false);
  async function handleCancelVerification() {
    await setopenVerification(false);
    await setopenSingle(true);
  }
  async function handleOpenVerification() {
    await setopenVerification(true);
    await setopenSingle(false);
    await handleCancel();
  }

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setShow();
  }

  const [formData, setFormData] = useState();
  const [show, setShow] = useState(singlePaymentObj?.paymentMethod);

  const [bankCode, setBankCode] = useState();

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    data.pdPayeeType = phPayeeType;
    data.pdPhId = pdPhId;
    data.pdStatus= "PENDING_PAYMENT"
    data.pdId = prodd?.pdId ?? null
    data.pdBankCode = bankCode;
    const res = await dispatch(
      save({
        ...data,
        url: "py/savePaymentDetails.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await setBankCode("");
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchBankData() {
    dispatch(fetchBank());
  }
  useEffect(() => { 
    if (prodd) { 
      form.setFieldsValue(prodd); 
    } else { 
      form.setFieldsValue({});
    }
  }, [prodd, form]); 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Payment Detail Modal`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          initialValues={prodd}
        >
          <Form.Item
            name="pdTransType"
            className=""
            label={<span>Payment Method</span>}
            rules={[
              {
                required: true,
                message: "Please select payment method",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                paymentMethodsData?.length > 0 &&
                paymentMethodsData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              onChange={(value) => {
                setShow(value);
              }}
              value={formData?.paymentMethod}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>
          <Form.Item
            name="pdReceiverName"
            label="Receiver Name"
            rules={[
              {
                required: true,
                message: "Enter receiver name for transfer",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>

          <Form.Item
            className="table-form-item"
            name="pdReceiverNumber"
            label="Receiver Number"
            rules={[
              {
                required: true,
                message: "Please add Receiver Number",
              },
              {
                validator: (_, value) => {
                  if (value && value.length === 12) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Phone number must be exactly 10 characters")
                  );
                },
              },
            ]}
          >
            <PhoneInput
              country="ke"
              countryCodeEditable={false}
              className="input"
            />
          </Form.Item>
          <Form.Item
            name="pdAmount"
            label="Amount"
            rules={[
              {
                required: true,
                message: "Enter amount",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              placeholder="Enter amount"
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            name="pdBankName"
            className=""
            label={<span>Bank</span>}
            rules={[
              {
                required: true,
                message: "Please select Bank",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                bank?.length > 0 &&
                bank?.map((item) => ({
                  value: item?.jbnkBankName,
                  label: item?.jbnkBankName,
                }))
              }
              onChange={(selectedBankName) => {
                const selectedBank = bank?.find(
                  (item) => item?.jbnkBankName === selectedBankName
                );
                setBankCode(selectedBank?.jbnkId);
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchBankData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>
          <Form.Item
            name="pdBankAccount"
            label="Bank Account Number"
            rules={[
              {
                required: true,
                message: "Enter Bank Account",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default PaymentDetailsModal;
